{
  "title": "Production Plan",
  "subtitle": "Raise BOM-based production orders for Finished/Semi-Finished Goods.",
  "add": "New Production Order",
  "view": "View",
  "edit": "Edit",
  "release": "Release",
  "close": "Close",
  "save": "Save",
  "cancel": "Cancel",
  "table": {
    "number": "Order Number",
    "material": "Material",
    "type": "Type",
    "bom": "BOM",
    "warehouse": "Warehouse",
    "plannedQty": "Planned Qty",
    "producedQty": "Produced Qty",
    "requiredQty": "Required Qty",
    "issuedQty": "Issued Qty",
    "pickedQty": "Picked Qty",
    "acceptedQty": "Accepted Qty",
    "status": "Status",
    "actions": "Actions",
    "productionOrder": "Production Order",
    "source": "Source",
    "date": "Date",
    "issuedBy": "Issued By",
    "lines": "Lines",
    "client": "Client"
  },
  "form": {
    "material": "Finished/Semi-Finished Good",
    "materialHint": "Only materials whose category is tagged Finished Good or Semi-Finished Good are offered — the material must also have an Active BOM.",
    "materialHintNoBom": "Only materials whose category is tagged Finished Good or Semi-Finished Good are offered — no Active BOM is required in this mode.",
    "warehouse": "Warehouse",
    "client": "Client",
    "plannedQty": "Planned Qty",
    "remarks": "Remarks",
    "modeBom": "BOM Request",
    "modeManual": "Manual",
    "modeExcel": "Excel Import",
    "modeManualShort": "Manual",
    "componentLines": "Component Lines (RM / Child Part / SFG)",
    "quantity": "Qty",
    "addLine": "Add Line",
    "excelHint": "Download the template, fill in Material Code and Qty for each RM/child-part/SFG component, then upload it — the parsed rows appear below for review before saving.",
    "downloadTemplate": "Download Template",
    "uploadFile": "Upload Filled Template",
    "excelRowMaterialNotFound": "Row {{row}}: material code '{{code}}' was not found.",
    "excelRowInvalidQty": "Row {{row}}: '{{code}}' needs a quantity greater than zero."
  },
  "pickList": {
    "title": "Production Pick List",
    "subtitle": "Generate and review the component pick list for a released production order — Material Issue can only post once a pick list exists.",
    "generate": "Generate Pick List",
    "selectOrder": "Production Order",
    "selectOrderHint": "Only released, still-open orders that don't already have a pick list are shown.",
    "location": "Location",
    "batch": "Batch",
    "barcode": "Barcode",
    "individualQty": "Individual Qty",
    "packingQty": "Packing Qty",
    "table": {
      "number": "Pick List Number"
    }
  },
  "materialIssue": {
    "title": "Material Issue",
    "subtitle": "Confirm and post a generated pick list's components — barcode-verify each line, then issue.",
    "selectPickList": "Production Pick List",
    "selectBatch": "Select Batch",
    "noBatch": "No batch",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelper": "Scan or type this line's barcode to confirm you're issuing the physical unit in hand.",
    "scannedOfTotal": "{{scanned}} / {{total}}",
    "scanned": "Scanned",
    "expectedBarcode": "Barcode to Scan: {{barcode}}",
    "noBarcodeBlocked": "Barcode Required is enabled in Process Configuration, but this item has no barcode or printed label — assign a Material barcode or print production labels before issuing.",
    "qtyToIssue": "Qty to Issue",
    "remaining": "Remaining: {{qty}}",
    "issueButton": "Issue Materials",
    "issuing": "Issuing...",
    "historyTitle": "Recent Issues",
    "mode": {
      "PickList": "Stock was auto-resolved (FIFO/strategy default) when the pick list was generated.",
      "BatchSelect": "Choose a batch below for any line the pick list left unresolved.",
      "ValidationOnly": "No batch/location resolution — quantity is simply deducted from on-hand stock."
    }
  },
  "receipt": {
    "title": "Production Receipt",
    "subtitle": "Post the Finished/Semi-Finished Good produced against a released production order, or against a completed Material Request.",
    "tabs": {
      "productionPlan": "Production Plan",
      "materialRequest": "Material Request"
    },
    "selectOrder": "Production Order",
    "selectMaterialRequest": "Material Request",
    "noEligibleMaterialRequests": "No Material Requests are eligible yet — picking against a request must complete (and its stock update) before it can be received against here.",
    "selectMaterial": "Finished/Semi-Finished Good Produced",
    "producedQty": "Produced Qty",
    "acceptedQty": "Accepted Qty",
    "rejectedQty": "Rejected Qty",
    "batchNo": "Batch No",
    "mfgDate": "Mfg Date",
    "expiryDate": "Expiry Date",
    "location": "Location",
    "locationNone": "Unassigned",
    "unitCost": "Unit Cost",
    "postButton": "Post Receipt",
    "posting": "Posting...",
    "planQtyExceeded": "Accepted + Rejected together cannot exceed this order's Planned Qty ({{plannedQty}})."
  }
}
